import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8eaeab62"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer-box"
};
const _hoisted_2 = {
  key: 0,
  class: "red-num"
};
const _hoisted_3 = {
  key: 1,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "28",
  height: "28"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.6615 2.17021L24.3385 7.53497C24.7478 7.76192 25 8.18134 25 8.63524V19.3648C25 19.8187 24.7478 20.2381 24.3385 20.465L14.6615 25.8298C14.2522 26.0567 13.7478 26.0567 13.3385 25.8298L3.66155 20.465C3.25218 20.2381 3 19.8187 3 19.3648L3 8.63524C3 8.18134 3.25218 7.76192 3.66155 7.53497L13.3385 2.17021C13.7478 1.94326 14.2522 1.94326 14.6615 2.17021Z",
  fill: "#3F85FF"
}, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M11 14L13.8586 16.8586C13.9367 16.9367 14.0633 16.9367 14.1414 16.8586L17 14",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14 10V15",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round"
}, null, -1));
const _hoisted_8 = [_hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7];
const _hoisted_9 = {
  key: 2,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10V14.5858L11.7071 13.2929C11.3166 12.9024 10.6834 12.9024 10.2929 13.2929C9.90237 13.6834 9.90237 14.3166 10.2929 14.7071L13.1515 17.5657C13.6201 18.0343 14.3799 18.0343 14.8485 17.5657L17.7071 14.7071C18.0976 14.3166 18.0976 13.6834 17.7071 13.2929C17.3166 12.9024 16.6834 12.9024 16.2929 13.2929L15 14.5858V10Z",
  fill: "#6A707C"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.1767 3.0448L23.8536 8.40956C23.9574 8.46712 24 8.55873 24 8.63524V19.3648C24 19.4413 23.9574 19.5329 23.8536 19.5904L14.1767 24.9552C14.0689 25.0149 13.9311 25.0149 13.8233 24.9552L4.14641 19.5904C4.0426 19.5329 4 19.4413 4 19.3648V8.63524C4 8.55873 4.0426 8.46712 4.14641 8.40956L13.8233 3.0448C13.9311 2.98507 14.0689 2.98507 14.1767 3.0448Z",
  stroke: "#61636F",
  "stroke-width": "2"
}, null, -1));
const _hoisted_12 = [_hoisted_10, _hoisted_11];
const _hoisted_13 = {
  key: 0,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<rect width=\"28\" height=\"28\" fill=\"none\" data-v-8eaeab62></rect><rect x=\"4\" y=\"4\" width=\"8\" height=\"8\" stroke=\"#61636F\" stroke-width=\"2\" data-v-8eaeab62></rect><rect x=\"4\" y=\"16\" width=\"8\" height=\"8\" stroke=\"#61636F\" stroke-width=\"2\" data-v-8eaeab62></rect><rect x=\"16\" y=\"4\" width=\"8\" height=\"8\" stroke=\"#61636F\" stroke-width=\"2\" data-v-8eaeab62></rect><rect x=\"16\" y=\"16\" width=\"8\" height=\"8\" stroke=\"#61636F\" stroke-width=\"2\" data-v-8eaeab62></rect>", 5);
const _hoisted_19 = [_hoisted_14];
const _hoisted_20 = {
  key: 1,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<rect width=\"28\" height=\"28\" fill=\"white\" data-v-8eaeab62></rect><rect x=\"3\" y=\"3\" width=\"10\" height=\"10\" rx=\"1\" fill=\"#3F85FF\" data-v-8eaeab62></rect><rect x=\"3\" y=\"15\" width=\"10\" height=\"10\" rx=\"1\" fill=\"#3F85FF\" data-v-8eaeab62></rect><rect x=\"15\" y=\"3\" width=\"10\" height=\"10\" rx=\"1\" fill=\"#3F85FF\" data-v-8eaeab62></rect><rect x=\"15\" y=\"15\" width=\"10\" height=\"10\" rx=\"1\" fill=\"#3F85FF\" data-v-8eaeab62></rect>", 5);
const _hoisted_26 = [_hoisted_21];
const _hoisted_27 = {
  key: 0,
  class: "point"
};
const _hoisted_28 = {
  key: 1,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  width: "28",
  height: "28"
}, null, -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14 3C10.6863 3 8 5.68629 8 9C8 12.3137 10.6863 15 14 15C17.3137 15 20 12.3137 20 9C20 5.68629 17.3137 3 14 3ZM22 9C22 11.8557 20.5037 14.3619 18.2524 15.7775C22.1791 17.2759 25 20.7904 25 25C25 25.5523 24.5523 26 24 26C23.4477 26 23 25.5523 23 25C23 20.6782 19.0723 17 14 17C8.92772 17 5 20.6782 5 25C5 25.5523 4.55228 26 4 26C3.44772 26 3 25.5523 3 25C3 20.7904 5.82093 17.2759 9.74761 15.7775C7.49628 14.3619 6 11.8557 6 9C6 4.58172 9.58172 1 14 1C18.4183 1 22 4.58172 22 9ZM15 19C15 18.4477 14.5523 18 14 18C13.4477 18 13 18.4477 13 19V23C13 23.5523 13.4477 24 14 24C14.5523 24 15 23.5523 15 23V19Z",
  fill: "#61636F"
}, null, -1));
const _hoisted_31 = [_hoisted_29, _hoisted_30];
const _hoisted_32 = {
  key: 2,
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M25 25C25 19.4772 20.0751 15 14 15C7.92487 15 3 19.4772 3 25C8.5 25 19.5 25 25 25Z",
  fill: "#3F85FF"
}, null, -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "14",
  cy: "9",
  r: "8",
  fill: "#3F85FF"
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14 18V23",
  stroke: "white",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1));
const _hoisted_36 = [_hoisted_33, _hoisted_34, _hoisted_35];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconTvCinemaNew = _resolveComponent("IconTvCinemaNew");
  return _ctx.show ? (_openBlock(), _createElementBlock("section", {
    key: 0,
    class: _normalizeClass({
      'footer': true,
      'is-dark': _ctx.currentPage === 'cinema'
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: "item",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.selectPage('home'))
  }, [_ctx.downloadAndPendingList.length > 0 && _ctx.status ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.num), 1)) : _createCommentVNode("", true), _ctx.currentPage === 'home' ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_8)) : _createCommentVNode("", true), _ctx.currentPage !== 'home' ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: _normalizeClass({
      'actived': _ctx.currentPage === 'home'
    })
  }, " 下载 ", 2)]), _ctx.isCinemaShowRef ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass({
      'item': true,
      'is-selected': _ctx.currentPage === 'cinema'
    }),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.selectPage('cinema'))
  }, [_createVNode(_component_IconTvCinemaNew, {
    height: "28",
    width: "28"
  }), _createElementVNode("p", {
    class: _normalizeClass({
      'actived': _ctx.currentPage === 'cinema'
    })
  }, " 个人片库 ", 2)], 2)) : _createCommentVNode("", true), _ctx.isPluginShowRef ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "item",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.selectPage('plugin'))
  }, [_ctx.currentPage !== 'plugin' ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_19)) : _createCommentVNode("", true), _ctx.currentPage === 'plugin' ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_26)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: _normalizeClass({
      'actived': _ctx.currentPage === 'plugin'
    })
  }, " 小工具 ", 2)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "item",
    onClick: _cache[3] || (_cache[3] = $event => _ctx.selectPage('me'))
  }, [_ctx.showPoint && _ctx.clientVersion.match(/2.13/) ? (_openBlock(), _createElementBlock("span", _hoisted_27)) : _createCommentVNode("", true), _ctx.currentPage !== 'me' ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_31)) : _createCommentVNode("", true), _ctx.currentPage === 'me' ? (_openBlock(), _createElementBlock("svg", _hoisted_32, _hoisted_36)) : _createCommentVNode("", true), _createElementVNode("p", {
    class: _normalizeClass({
      'actived': _ctx.currentPage === 'me'
    })
  }, " 我的 ", 2)])])], 2)) : _createCommentVNode("", true);
}